import React, { useState } from 'react';
import VaultexLogo from "../../../Assets/vaultex-logo.svg";
import { login } from '../../../services/auth';
import { ILoginFormData } from '../../../types/auth';

const Login = () => {
  const [formData, setFormData] = useState<ILoginFormData>({ username: '', password: '' });
  const [error, setError] = useState('');

  const handleChange = (e: any) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setError('');

    try {
      const response = await login(formData)
      if (!response?.success) {
        setError(response?.error)
        return false
      }
      localStorage.setItem("authToken", response.data?.access_token)
      console.log("Login success:", response);
      window.location.href = "/admin/dashboard";

    } catch (err: any) {
      setError(err.message);
    }
  };

  return (
    <div className="min-h-screen bg-[#f1f1f1] flex items-center justify-center py-12 px-4">
      <div className="w-full max-w-md bg-white shadow-md p-8 rounded-md border border-gray-200">
        <div className="flex justify-center mb-6">
          <img src={VaultexLogo} alt="Vaultex Logo" className="max-w-[150px]" />
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <input type="text" value={formData.username} name='username' onChange={handleChange} className="text-base font-light !leading-[1.5] text-[#020303] border border-[#03030380] py-2 px-5 placeholder-[#020303] outline-none hover:border-[#009fe3] focus:border-[#009fe3] w-full" placeholder="Username or Email" />
          </div>
          <div>
            <input type="password" value={formData.password} name='password' onChange={handleChange} className="text-base font-light !leading-[1.5] text-[#020303] border border-[#03030380] py-2 px-5 placeholder-[#020303] outline-none hover:border-[#009fe3] focus:border-[#009fe3] w-full" placeholder="Password" />
          </div>
          <button type="submit" className="w-full text-base font-semibold !leading-[1.5] text-[#ffffff] bg-[#009FE3] py-3 px-5 hover:bg-[#020303] transition-all duration-300 ease-in-out mx-auto">Log In</button>
          {error && <div className="text-red-600 text-sm">{error}</div>}
        </form>
      </div>
    </div>
  );
};

export default Login;